import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "17", r: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 7v6h6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "UndoDot";
const UndoDot = memo(themed(Icon));
export {
  UndoDot
};
//# sourceMappingURL=undo-dot.js.map
